import { observer } from "mobx-react"
import * as React from "react"
import dayjs from "dayjs"
import { Member } from "../db/BookingLightDB"
import Select from "BookingSystem/components/Select"

interface Props {
  member: Member | null
  style?: Object
}

@observer
class YearInput extends React.Component<Props> {
  render() {
    const { member, style } = this.props

    const years = () => {
      let yearsArr = []
      let currYear = dayjs().year()
      for (let i = currYear; i > currYear - 110; i--) {
        yearsArr.push(i.toString())
      }
      return yearsArr
    }

    return (
      <Select
        value={
          member && member.object.dobYear && member.object.dobYear.length > 0
            ? member.object.dobYear
            : "Year"
        }
        onChange={(event: any) =>
          member != undefined
            ? (member.object.dobYear = event.target.value)
            : null
        }
        style={style}
      >
        {years().map((year: string, i: number) => (
          <option key={i} value={year}>
            {year}
          </option>
        ))}
      </Select>
    )
  }
}

export default YearInput
